import React from "react";
import { Card, Col, Row, useMessagedAsync } from "@payping/web-components";
import { getUserWizardInfo } from "@payping/redux/actions";
import { ShaparakWizardStatusEnum } from "@payping/api";
import wizardStyle from "@/assets/scss/Wizard.module.scss";
import { useAppDispatch, useAppSelector } from "@/utils/redux";
import WizardBox from "./wizardBox";
import { WizardBoxType } from "./types";
import {
  adminConfirmState,
  adminPendingState,
  adminRejectState,
  defaultState,
  shaparakPendingState,
  shaparakRejectState,
  successState,
  userPendingState,
} from "./constants";

const Wizard: React.FC = () => {
  const dispatch = useAppDispatch();
  const wizard = useAppSelector((state) => state.user.wizard);

  useMessagedAsync(() => dispatch(getUserWizardInfo()), [], { useProgress: true });

  let userActivationState: WizardBoxType[] = defaultState;

  if (wizard) {
    if (wizard.terminalStatus) userActivationState = successState;
    else
      switch (wizard.userInfoStatus) {
        case ShaparakWizardStatusEnum.NotCompleted:
          userActivationState = userPendingState;
          break;
        case ShaparakWizardStatusEnum.AdminPending:
          userActivationState = adminPendingState;
          break;
        case ShaparakWizardStatusEnum.AdminConfirm:
          userActivationState = adminConfirmState;
          break;
        case ShaparakWizardStatusEnum.ShaparakPending:
          userActivationState = shaparakPendingState;
          break;
        case ShaparakWizardStatusEnum.Success:
          userActivationState = successState;
          break;
        case ShaparakWizardStatusEnum.AdminRejected:
          userActivationState = adminRejectState;
          break;
        case ShaparakWizardStatusEnum.ShaparakRejected:
          userActivationState = shaparakRejectState;
          break;
        default:
          userActivationState = userPendingState;
          break;
      }
  }

  return (
    <Card.Raw>
      <Row align="stretch" justify="space-between" className="h-100">
        {userActivationState.map((statusProps, i) => (
          <Col xs={24} md={12} xl={6} key={i} className={wizardStyle.wizardBox}>
            {statusProps && <WizardBox {...statusProps} reason={wizard?.reason} />}
          </Col>
        ))}
      </Row>
    </Card.Raw>
  );
};

export default Wizard;
